import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { DeductionMethod, KeyValues10, KeyValues20, KeyValues3, KeyValues5, KeyValueSet, LocalService, Paging, PlanPurchaseInvoiceDetailInitialization, PlanPurchaseInvoiceInitialization, PlanPurchaseInvoiceStatus, StatusWithId, Wrappers10, Wrappers15, Wrappers5 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';
import { ExcelData } from './file-save.service';

@Injectable({
  providedIn: 'root'
})
export class PlanPurchaseService {
  private controllerName = service_controllers_methods.planPurchase.controller;
  private methods = service_controllers_methods.planPurchase.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getNewPlanPurchaseInvoice(businessId: string, interactionTypeForInvoice: number, b2bAccountId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: interactionTypeForInvoice.toString(), v3: b2bAccountId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNewPlanPurchaseInvoice, body);
  }

  public setInvoiceStatus(invoiceId: string, planPurchaseInvoiceStatus: PlanPurchaseInvoiceStatus, deductionMethod?: DeductionMethod, totalValue?: number): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: invoiceId, v2: planPurchaseInvoiceStatus.toString(), v3: deductionMethod ? deductionMethod.toString() : undefined, v4: totalValue ? totalValue.toString() : undefined } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SetInvoiceStatus, body);
  }

  public savePlanPurchaseInvoiceDetail(data: KeyValues20): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePlanPurchaseInvoiceDetail, body);
  }

  public getPlanPurchaseInvoiceInitialization(businessId: string, interactionTypeForInvoice: number, b2bAccountId: string): Observable<PlanPurchaseInvoiceInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: interactionTypeForInvoice.toString(), v3: b2bAccountId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPlanPurchaseInvoiceInitialization, body);
  }

  public getPlanPurchaseInvoices(businessId: string, interactionTypeForInvoice: number, b2bAccountId: string, paging?: Paging): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: interactionTypeForInvoice.toString(), v3: b2bAccountId } as KeyValues3,
      pag: paging,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPlanPurchaseInvoices, body);
  }

  public getPlanPurchaseInvoiceDetail(itemId: string): Observable<KeyValues20> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: itemId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPlanPurchaseInvoiceDetail, body);
  }

  public getPlanPurchaseInvoiceDetailInitialization(invoiceId: string): Observable<PlanPurchaseInvoiceDetailInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: invoiceId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPlanPurchaseInvoiceDetailInitialization, body);
  }

  public deletePlanPurchaseInvoiceDetail(itemId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: itemId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeletePlanPurchaseInvoiceDetail, body);
  }

  public buyPlanPurchaseInvoice(invoiceId: string, deductionMethod: DeductionMethod): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: invoiceId, v2: deductionMethod.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.BuyPlanPurchaseInvoice, body);
  }

  public getInvoice(invoiceId: string, isExternal: boolean): Observable<KeyValueSet> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: invoiceId, v2: isExternal ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetInvoice, body);
  }

  public getInvoices(isIncludeZero: boolean, paging?: Paging): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: isIncludeZero ? '1' : '0' } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetInvoices, body);
  }

  public getExcelData(isIncludeZero: boolean, paging?: Paging): Observable<ExcelData> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: isIncludeZero ? '1' : '0' } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetExcelData, body);
  }

  public uploadInvoiceToDrive(invoiceId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: invoiceId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UploadInvoiceToDrive, body);
  }

  public removeToGst(invoiceId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: invoiceId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RemoveToGst, body);
  }

  public refreshToGst(isIncludeZero: boolean, paging?: Paging): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: isIncludeZero ? '1' : '0' } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RefreshToGst, body, true, false, true);
  }

  public getB2bLicenseSummary(b2bId: string): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: b2bId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetB2bLicenseSummary, body);
  }

  public getUtilizedLincenseDetails(b2bId: string, paging?: Paging): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: b2bId } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetUtilizedLincenseDetails, body);
  }

  public getPlanSubscriptions(paging?: Paging): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPlanSubscriptions, body);
  }
}
